import React, { Component } from "react";

class ModalHeader extends Component {
  render() {
    const { title } = this.props;
    return (
      <div className="modal-header">
        <h5 className="modal-title">
          <b>{title}</b>
        </h5>
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={this.props.toggleModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    );
  }
}

export default ModalHeader;
